import { render } from "./ViewContact.vue?vue&type=template&id=2bf89929&scoped=true"
import script from "./ViewContact.vue?vue&type=script&lang=js"
export * from "./ViewContact.vue?vue&type=script&lang=js"

import "./ViewContact.vue?vue&type=style&index=0&id=2bf89929&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2623155984/src/jamakkol-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf89929"]])

export default __exports__